import { useNavigate } from "react-router-dom";
import style from './index.module.css';
import Footer from '../moduls/footer';
import TextSwitcher from '../moduls/textswitch';
export default function IndexPage({login , setLogin,user, setUser}) {
    const navigate = useNavigate();
   

  return (
    <div className={style.page}>
         <div className={style.fire1} />

        <div className={style.fire2} />
        
        <div className={style.container}>
            <div className={style.header}>
                <div className={style.logo}>I’m-GPT</div>
                <div className={style.enter} onClick={() => navigate("/chat?login")}>
                    <img src='img/enter.png' alt='Войти'/>
                    <p>{login ? user?.email : 'Войти'}</p>
                </div>
            </div>
            <div className={style.one}>
                <h1>I’m-GPT</h1>
                <h2>Я тот самый чат который вы так долго искали</h2>
                <TextSwitcher/>
                <button className={style.btn} onClick={() => window.location.href="#toscroll"}>Открыть чат</button>
            </div>
        </div>
        <img src='img/bg.png' className={style.bgone} alt='bg'/>
        <div className={style.container}>
            <div className={style.two}>
                <h3>Нейросеть для любых задач</h3>
                <div className={style.cards}>
                    <div className={style.card}>
                        <div className={style.flexleft}>
                            <h4>Нейросеть для Экономии</h4>
                            <p>Мы научили нейросеть искать действующие промокоды, чтобы каждая ваша покупка была выгоднее.</p>
                             <img src='img/promo.png' className={style.mincard} alt='img'/>
                            <div className={style.flexbtn}>
                                <button className={style.btn} onClick={() => navigate("/chat?register&utm_source=promo")}>Получить доступ</button>
                                <button className={style.gredbtn} onClick={() => navigate("/ipromo")}>Инструкция как пользоваться</button>
                            </div>
                        </div>
                        <img src='img/promo.png' className={style.maxcard} alt='img'/>
                    </div>
                    
                    <div className={style.card}>
                        <div className={style.flexleft}>
                            <h4>Нейросеть для Бизнеса</h4>
                            <p>Мы научили нейросеть анализировать данные, находить лучшие решения и помогает снижать затраты, повышать продажи</p>
                             <img src='img/bus.png' className={style.mincard} alt='img'/>
                            <div className={style.flexbtn}>
                                <button className={style.gredbtn2} disabled>В разработке</button>
                                <button className={style.gredbtn}>Скоро появится</button>
                            </div>
                        </div>
                        <img src='img/bus.png' className={style.maxcard} alt='img'/>
                    </div>

                </div>
            </div>
            <div className={style.three}>
                <h3>Как обучается I’m-GPT </h3>
                <h4>Мы постоянно учим I’m-GPT, чтобы он становился умнее и полезнее</h4>
                <div className={style.scroll}>
                    <div className={style.flexinfo}>
                        <div className={style.info}>
                            <img src='img/info1.png' alt='info'/>
                            <h5>Реальные данные</h5>
                            <p>Только проверенная информация</p>
                        </div>
                        <div className={style.info}>
                            <img src='img/info3.png' alt='info'/>
                            <h5>Надежные источники</h5>
                            <p>Никакой фейковой информации</p>
                        </div>
                        <div className={style.info}>
                            <img src='img/info2.png' alt='info'/>
                            <h5>Частое дообучение</h5>
                            <p>Актуальные данные каждый день</p>
                        </div>
                        <div className={style.info}>
                            <img src='img/info4.png' alt='info'/>
                            <h5>Контроль качества</h5>
                            <p>Оценка и улучшение ответов</p>
                        </div>
                    </div>
                </div>
                <div className={style.flexline}>
                    <div className={style.line}>
                        <hr className={style.left}/>
                    </div>
                    <p>Настройка I’m-GPT</p>
                    <div className={style.line}>
                        <hr className={style.right}/>
                    </div>
                    
                </div>
            </div>
            <div className={style.four}>
                <a name="toscroll"></a>
                <h3>Единый доступ ко всем возможностям I’m-GPT</h3>
                <p>При необходимости вы можете пополнить токены в личном кабинете, если текущего лимита окажется недостаточно.</p>
                <div className={style.price}>
                    <div className={style.leftprice}>
                        <h4>Первая неделя 1₽ далее 599₽/месяц</h4>
                        <h5>На основании опыта работы с I’m-GPT мы пришли к единому мнению и представляем вам единый тариф</h5>
                        <div className={`${style.razdel} ${style.mobile}`}></div>
                        <ul className={`${style.plusprice} ${style.mobile}`}>
                            <li>
                                <img src='img/price1.png' alt='price'/>
                                <p>350 000 токенов</p>
                            </li>
                            <li>
                                <img src='img/price2.png' alt='price'/>
                                <p>Высокая скорость обработки</p>
                            </li>
                            <li>
                                <img src='img/price3.png' alt='price'/>
                                <p>Регулярные обновления системы</p>
                            </li>
                            <li>
                                <img src='img/price4.png' alt='price'/>
                                <p>Техническая поддержка</p>
                            </li>
                        </ul>
                        <button className={style.btn} onClick={() => navigate("/chat?register&utm_source=index")}>Получить доступ</button>
                        <h6>Отмена в любой момент без потери запросов</h6>
                    </div>
                    <div className={`${style.razdel} ${style.desktop}`}></div>
                    <div className={style.rightprice}>
                        <ul className={`${style.plusprice} ${style.desktop}`}>
                            <li>
                                <img src='img/price1.png' alt='price'/>
                                <p>350 000 токенов</p>
                            </li>
                            <li>
                                <img src='img/price2.png' alt='price'/>
                                <p>Высокая скорость обработки</p>
                            </li>
                            <li>
                                <img src='img/price3.png' alt='price'/>
                                <p>Регулярные обновления системы</p>
                            </li>
                            <li>
                                <img src='img/price4.png' alt='price'/>
                                <p>Техническая поддержка</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className={style.five}>
                <h3>Клиент-центр</h3>
                <h4>Наша приоритетная задача - сделать ваше взаимодействие с I’m-GPT максимально комфортным и безопасным</h4>
                <div className={style.flexsupport}>
                    <div className={style.leftsupport}>
                        <h5>Возврат средств</h5>
                        <p>Если вам не понравился сервис, <span>вы имеете право запросить возврат средств в течение 10 дней.</span></p>
                        <ul className={style.supportli}>
                            <li>Оперативное рассмотрение</li>
                            <li>Быстрая обработка</li>
                            <li>Ваши данные надежно защищены</li>
                        </ul>
                        <button className={style.btng} onClick={() => navigate("/charge")}>Заполнить заявление</button>
                    </div>
                    <div className={style.rightsupport}>
                        <img src='img/supportblock.png' alt='support' className={`${style.desktop}`}/>
                        <div className={style.leftsupport}>
                            <h5>Нужна помощь?</h5>
                            <h6>Наша поддержка с радостью вам поможет, в решении вашей проблемы</h6>
                            <div className={style.h7}>Режим работы поддержки: <span>с 10:00 до 17:00</span></div>
                            <div className={style.h7}>По электронной почте: <span>im-gpt.ru@yandex.ru</span></div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
    </div>
  );
}
